import type { Role } from "@scs/contracts";
import type { ReactNode } from "react";
import { Navigate } from "react-router";
import type { AuthSession } from "../api/client.js";

export type RouteAccess = "allowed" | "forbidden" | "unauthenticated";

export function getRouteAccess(
  session: AuthSession | null,
  allowedRoles: readonly Role[]
): RouteAccess {
  if (session === null) return "unauthenticated";
  return allowedRoles.includes(session.user.role) ? "allowed" : "forbidden";
}

export function ProtectedRoute(props: {
  allowedRoles: readonly Role[];
  children: ReactNode;
  session: AuthSession | null;
}): ReactNode {
  const access = getRouteAccess(props.session, props.allowedRoles);
  if (access === "unauthenticated") {
    return <Navigate replace to="/login" />;
  }
  if (access === "forbidden") {
    return <section role="alert">无权访问此页面。</section>;
  }
  return props.children;
}
